import { get } from '@webapp-next/lib/request/webapp/apiv2';

export type EmployeeLeaveEntitlementsError = {
  code: string | number;
  details?: [];
  message: string;
};

export type EmployeeLeaveEntitlmentsData = {
  leaveRuleIds: number[] | [];
};

export type GetemployeeLeaveEntitlments = {
  success: boolean;
  leaveEntitlements?: EmployeeLeaveEntitlmentsData | undefined;
  error?: EmployeeLeaveEntitlementsError | undefined | string;
};

export default async function getEmployeeLeaveEntitlementIdsByEmployeeId(
  employeeId: number
): Promise<EmployeeLeaveEntitlmentsData> {
  try {
    const { data: response } = (await get(
      `/api/management/v2/leave-entitlements/employees/${employeeId}`
    )) as { data: GetemployeeLeaveEntitlments };

    if (response?.success === false) {
      throw new Error('Failed to retrieve employee leave entitlement data');
    }

    return response.leaveEntitlements as EmployeeLeaveEntitlmentsData;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
